import { Paper } from "@mui/material";

const MainContent = props => {
    return <>
        <Paper
            sx={{
                flexGrow: 1,
                p: { xs: 1, sm: 3 },
                width: { xs: '100dvw', sm: 'auto' },
                minHeight: { xs: '100dvh', sm: 'auto' },
                boxSizing: { xs: 'border-box', sm: 'initial' }
            }}
            elevation={3}>
            {props.content}
        </Paper>
    </>;
};

export default MainContent;
